import MultiEditFail from './MultiEditFail';

export default MultiEditFail;
